module.exports = __webpack_public_path__ + "img/oriental-bg-l.b0dd648.webp";